import { FC, useEffect, memo } from 'react';

import { attrItems, defaultGroupingsAd, defaultMetricsAd, filtersFilter } from './constants';
import { isAccessEnded } from '../../helpers/utils/functions';
import MainLayout from '../../shared/common/components/layouts/MainLayout';
import Loader from '../../shared/common/components/loader/Loader';
import ReportChart from '../../shared/common/components/reports/chart/ReportChart';
import ReportTable from '../../shared/common/components/reports/report-table';
import CreateMetricsModal from '../../shared/common/components/reports/CreateMetricsModal';
import Params from '../../shared/common/components/reports/params/Params';
import UniversalReportTitle from '../../shared/common/components/reports/un-title/UniversalReportTitle';
import { chartDetails } from '../../shared/common/constants/details';
import { useTypedSelector } from '../../shared/common/hooks/useTypedSelector';
import { useReportPageInit } from '../../shared/common/hooks/useReportPageInit';

const ADReports: FC = () => {
    // Используем универсальный хук для инициализации страницы отчёта
    const { isChartLoading } = useReportPageInit({
        defaultMetrics: defaultMetricsAd,
        defaultGroupings: defaultGroupingsAd,
    });
    
    useEffect(() => {
        document.body.style.overflow = 'scroll';
        document.body.style.overflowX = 'auto';
        
        return () => {
            document.body.style.overflow = '';
            document.body.style.overflowX = '';
        };
    }, []);
    
    const { isCreateMetricsVisible } = useTypedSelector((state) => state.reports);
    const accessEnded = isAccessEnded();
    
    return (
        <>
            <MainLayout pageTitle="Отчёт по рекламе">
                <div className="page-wrapper">
                    {accessEnded ? (
                        <iframe
                            style={{ border: 'none', width: '990px', float: 'left', minHeight: '100vh', marginTop: '2vh' }}
                            src={`https://doc.scananalytics.ru/oshibki-i-preduprezhdeniya/dostup-k-otchetu-po-reklame-zakryt/?timestamp=${new Date().getTime()}`}
                            width="100%"
                            height="100%"
                        />
                    ) : (
                        <div className="page-content">
                            <UniversalReportTitle />
                            <Params
                                attributionItems={attrItems}
                                detailsItems={chartDetails}
                                filtersFilter={filtersFilter}
                            />
                            <Loader loading={isChartLoading}>
                                <ReportChart reportType="ad" />
                            </Loader>
                            <ReportTable reportType="ad" />
                        </div>
                    )}
                </div>
            </MainLayout>

            {isCreateMetricsVisible && (<CreateMetricsModal title="Создание метрики в отчете по рекламе" />)}
        </>
    );
};

export default memo(ADReports);
